exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal .btn.btn-arrow[data-v-75e37556]{min-width:140px}.modal .btn-outline-secondary+.btn-arrow[data-v-75e37556]{margin:auto;margin-right:0}.modal .alert-top[data-v-75e37556]{margin-top:30px}", ""]);

// exports
